import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AdminGuard } from "@/components/admin/AdminGuard";
import { errText } from "@/lib/api";
import { adminBundles, adminSaveBundle } from "@/lib/admin";
import { cad } from "@/lib/site";

const NEW = { slug: "", name: "", image: "/img/crew_bundle.webp", price: 99, description: "", active: true, slots: [{ key: "item", label: "Pick one", type: "category", category: "tees", product_slug: null, slugs: [] }] };
const strip = (slots) => slots.map(({ options, ...s }) => s);

const Editor = ({ b, onSaved }) => {
  const [f, setF] = useState({ ...b, slotsText: JSON.stringify(strip(b.slots), null, 2) });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const tid = b.slug || "new";
  const save = async () => {
    let slots;
    try { slots = JSON.parse(f.slotsText); } catch { return toast.error("Slots must be valid JSON"); }
    try { await adminSaveBundle(b.slug, { name: f.name, slug: f.slug || undefined, image: f.image, price: +f.price, description: f.description, active: f.active, slots }); toast.success("Bundle saved"); onSaved(); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <div className="rounded-[24px] border-[1.5px] border-ink p-6" data-testid={`admin-bundle-${tid}`}>
      <div className="grid gap-4 md:grid-cols-4">
        <label className="md:col-span-2"><span className="label text-ink/60">Name</span><input value={f.name} onChange={set("name")} className="field" data-testid={`admin-bundle-name-${tid}`} /></label>
        <label><span className="label text-ink/60">Fixed price (C$)</span><input type="number" value={f.price} onChange={set("price")} className="field" data-testid={`admin-bundle-price-${tid}`} /></label>
        <label className="flex items-end gap-2 pb-3"><input type="checkbox" checked={f.active} onChange={set("active")} data-testid={`admin-bundle-active-${tid}`} /> Active</label>
        <label className="md:col-span-2"><span className="label text-ink/60">Image path or URL</span><input value={f.image} onChange={set("image")} className="field" data-testid={`admin-bundle-image-${tid}`} /></label>
        <label className="md:col-span-2"><span className="label text-ink/60">Description</span><input value={f.description} onChange={set("description")} className="field" data-testid={`admin-bundle-desc-${tid}`} /></label>
        <label className="md:col-span-4"><span className="label text-ink/60">Slots (JSON: type fixed + product_slug, category + category, or list + slugs)</span><textarea rows={7} value={f.slotsText} onChange={set("slotsText")} className="field font-mono text-xs" data-testid={`admin-bundle-slots-${tid}`} /></label>
      </div>
      <div className="mt-4 flex items-center justify-between">{b.value !== undefined && <p className="text-sm text-ink/60">Value {cad(b.value)} · saves {cad(b.save)}</p>}<button onClick={save} className="btn btn-ink" data-testid={`admin-bundle-save-${tid}`}>{b.slug ? "Save bundle" : "Create bundle"}</button></div>
    </div>
  );
};

const Panel = () => {
  const [rows, setRows] = useState(null);
  const load = () => adminBundles().then(setRows);
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-6" data-testid="admin-bundles">
      <h1 className="display text-6xl">Bundles</h1>
      {rows?.map((b) => <Editor key={b.slug + b.price} b={b} onSaved={load} />)}
      <p className="label font-bold">New bundle</p>
      <Editor b={NEW} onSaved={load} />
    </div>
  );
};

export default function AdminBundles() {
  return <AdminGuard><Panel /></AdminGuard>;
}
